import React, { useState, useEffect } from "react";
import axios from "axios";
import { VerticalGraph } from "./VerticalGraph";

// import { holdings } from "../data/data";

const Holdings = () => {
    const [allHoldings, setAllHoldings] = useState([]);

    const [isAuthed, setIsAuthed] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            setIsAuthed(false);
            return;
        }
        setIsAuthed(true);
        axios
            .get("https://tradepulse-kcou.onrender.com/allHoldings", {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setAllHoldings(res.data);
            })
            .catch((err) => {
                console.error(err);
                setIsAuthed(false);
            });
    }, []);

    // const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const labels = allHoldings.map((subArray) => subArray["name"]);

    const data = {
        labels,
        datasets: [
            {
                label: "Stock Price",
                data: allHoldings.map((stock) => stock.price),
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
        ],
    };

    // export const data = {
    //   labels,
    //   datasets: [
    // {
    //   label: 'Dataset 1',
    //   data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
    //   backgroundColor: 'rgba(255, 99, 132, 0.5)',
    // },
    //     {
    //       label: 'Dataset 2',
    //       data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
    //       backgroundColor: 'rgba(53, 162, 235, 0.5)',
    //     },
    //   ],
    // };

    return (
        <>
            <h3 className="title">
                Holdings ({isAuthed ? allHoldings.length : 0})
            </h3>

            {!isAuthed && (
                <div className="alert alert-warning">
                    Please log in to view your holdings.
                </div>
            )}

            <div className="order-table">
                <table>
                    <tr>
                        <th>Instrument</th>
                        <th>Qty.</th>
                        <th>Avg. cost</th>
                        <th>LTP</th>
                        <th>Cur. val</th>
                        <th>P&L</th>
                        <th>Net chg.</th>
                        <th>Day chg.</th>
                    </tr>

                    {isAuthed &&
                        allHoldings.map((stock, index) => {
                            const curValue = stock.price * stock.qty;
                            const isProfit =
                                curValue - stock.avg * stock.qty >= 0.0;
                            const profClass = isProfit ? "profit" : "loss";
                            const dayClass = stock.isLoss ? "loss" : "profit";

                            return (
                                <tr key={index}>
                                    <td>{stock.name}</td>
                                    <td>{stock.qty}</td>
                                    <td>{stock.avg.toFixed(2)}</td>
                                    <td>{stock.price.toFixed(2)}</td>
                                    <td>{curValue.toFixed(2)}</td>
                                    <td className={profClass}>
                                        {(
                                            curValue -
                                            stock.avg * stock.qty
                                        ).toFixed(2)}
                                    </td>
                                    <td className={profClass}>{stock.net}</td>
                                    <td className={dayClass}>{stock.day}</td>
                                </tr>
                            );
                        })}
                </table>
            </div>

            <div className="row">
                <div className="col">
                    <h5>
                        29,875.<span style={{ display: 'inline' }}>55</span>
                    </h5>
                    <p>Total investment</p>
                </div>
                <div className="col">
                    <h5>
                        31,428.<span style={{ display: 'inline' }}>95</span>
                    </h5>
                    <p>Current value</p>
                </div>
                <div className="col">
                    <h5>1,553.40 (+5.20%)</h5>
                    <p>P&L</p>
                </div>
            </div>
            {isAuthed && <VerticalGraph data={data} />}
        </>
    );
};

export default Holdings;
